import React from "react";
import "./MoveSummaryCard.scss"
import { MoveListCard } from "components/moveListCard";
import { CardLayout } from "components/cardLayout";
import { getEstFlowEstimateDetails, getEstimatorInventory } from "../../core/services/moveDetailsByCustomer"
import { getCustomerDetails } from 'core/services/getCustomerDetailsService'
import { getEstimatorPacking } from 'core/services/getEstimatorPacking'
//@ts-ignore
// import SimpleLineIcon from 'react-simple-line-icons';
// import '../../../node_modules/font-awesome/css/font-awesome.min.css'
import { MdClose } from "react-icons/md";
//@ts-ignore
import SignatureCanvas from 'react-signature-canvas'
import { client } from "App";
import { saveSignatures } from '../../core/services/saveSignatures'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Spinner from '../spinner/spinner';
//import { sign } from "crypto";

export interface MoveSummaryCardProps {
    onClick?(): void;
    getSignFlag?: any
}

export interface MoveSummaryCardState {
    loading: boolean
    data: any
    transportData: any;
    responseEstDetail: any,
    inventoryData: any,
    inventoryUniqueRow: any,
    customerDetails: any,
    EstimatorDetails: any,
    signErrorMsg: any


}


class MoveSummaryCard extends React.Component<MoveSummaryCardProps, MoveSummaryCardState> {
    private _isMounted: boolean = false
    sigCanvasFirst: any;
    sigCanvasSecond: any;
    firstSignPadRef: any;
    sliderRef: any;

    constructor(props: MoveSummaryCardProps) {
        super(props);
        //debugger;
        this.state = {
            loading: true,
            transportData: [],
            responseEstDetail: {},
            inventoryData: [],
            inventoryUniqueRow: [],
            customerDetails: {},
            EstimatorDetails: {},
            data: {
                t: "$6000",
                p: "$560",
                m: "$45678"
            },
            signErrorMsg: ""
        };


    }

    clearFirst = () => {
        // if(this.props.formControl){
        //     this.props.formControl.reset();
        // }
        this.props.getSignFlag("")
        this.sigCanvasFirst.clear();

    }
    componentDidMount() {

        console.log("componentDidMount")

        //this.setState({loading:false});
        this._isMounted = true;
        var cid = (localStorage.getItem("CID") || "");
        var securetoken = localStorage.getItem("securetoken") || "";
        var cusDetails: any = localStorage.getItem("customerDetails")

        let customerDetails = JSON.parse(cusDetails)
        console.log("Local Customer Data INNNNNN", customerDetails);
        this.setState({ customerDetails: customerDetails });
        //this.getData(cid);
        Promise.all([

            this.getEstFlowEstimateDetails(cid),
            this.getEstimatorInventory(cid),
            this.getEstimatorPacking(cid)
        ]).then((response: any[]) => {
            console.log("RESPONSEEEEEEEEEEEEEEEE", response)
            if (this._isMounted) {
                // let responseCustDetail = response[0][0];
                // localStorage.setItem("customerDetails", JSON.stringify(responseCustDetail));
                var custDetails = JSON.parse(localStorage.getItem("customerDetails") || "{}");
                // console.log("RESPONSEEEEEEEEEEEEEEEE", response)
                const responseEstDetail = response[0][0];
                console.log("RESPONSE", responseEstDetail)
                this.setState({ responseEstDetail: responseEstDetail });
                //localStorage.setItem("estFlowEstimateDetails", JSON.stringify(responseEstDetail));

                var transportDataArr = [
                    { type: 'Loading', summary: responseEstDetail.loadTrucks + ' Truck, ' + responseEstDetail.loadCrewSize + ' Movers ', amount: '$' + Number((responseEstDetail.loadRate * responseEstDetail.loadEstimatedHours)).toFixed(2), hour: '' },
                    { type: 'Unloading', summary: responseEstDetail.loadTrucks + ' Truck, ' + responseEstDetail.loadCrewSize + ' Movers ', amount: '$' + Number((responseEstDetail.unloadRate * responseEstDetail.unloadEstimatedHours)).toFixed(2), hour: '' },
                    { type: 'Travel', summary: '', amount: '$' + Number((responseEstDetail.travelRate * responseEstDetail.travelHours)).toFixed(2), hour: ' ' },
                    { type: 'Fuel', summary: '', amount: '$' + responseEstDetail.fuelCharge, hour: '' },
                    { type: 'Materials', summary: '', amount: '$' + responseEstDetail.materialCost, hour: '' },
                    { type: 'Packing Cost', summary: '', amount: '$' + responseEstDetail.packingCost, hour: '' },
                    { type: 'Additional Services', summary: '', amount: '$' + responseEstDetail.additionalCharges, hour: '' },
                    { type: 'Additional coverage and protection charges', summary: '', amount: '$' + responseEstDetail.protectionCharges, hour: '' },
                    { type: 'AMS Adjustment', summary: '', amount: '$' + responseEstDetail.discountValue, hour: '' },
                    { type: 'Pass through charges', summary: '', amount: '$' + Number((parseFloat(responseEstDetail.abfVal) + parseFloat(responseEstDetail.thirdPartyService))).toFixed(2), hour: '' },
                ]
                this.setState({ transportData: transportDataArr, loading: false });
                var inventory = response[1];
                this.setState({ inventoryData: inventory });
                this.setState({ EstimatorDetails: JSON.parse(localStorage.getItem("EstimatorDetails") || "") })
                localStorage.setItem("Packing", JSON.stringify(transportDataArr));

                var inventoryUniqueNames: any = [];
                const inventoryObj = this.state.inventoryData.filter((item: { name: any; }) => {
                    var idx = inventoryUniqueNames.findIndex((x: { name: any; }) => x.name == item.name);
                    if (idx <= -1) {
                        inventoryUniqueNames.push({ name: item.name });
                    }
                });
                console.log("UNIQUE", inventoryUniqueNames)
                this.setState({ inventoryUniqueRow: inventoryUniqueNames, loading: false });
            }
        });


    }

    componentWillUnmount() {
        this._isMounted = false;
        console.log("componentWillUnmount")
    }

    async getCustomerDetails(cid: string, securetoken: string) {
        return await getCustomerDetails(cid, securetoken)
    }

    async getEstFlowEstimateDetails(cid: string) {
        return await getEstFlowEstimateDetails(cid)
    }

    async getEstimatorInventory(cid: string) {
        return await getEstimatorInventory(cid)
    }

    // cgetEstimatorPacking
    async getEstimatorPacking(cid: string) {
        return await getEstimatorPacking(cid)
    }
    sumProperty(arr: any, type: any) {
        return arr.reduce((total: number, obj: any) => {
            if (typeof obj[type] === 'string') {
                return total + Number(obj[type].replace('$', ''));
                //return total + Number(obj[type]);
            }
            return total + obj[type].replace('$', '');
            //return total + obj[type];
        }, 0);
    }
    renderInventory() {
        const items = this.state.inventoryUniqueRow.map((item: any, index: number) => {

            var nestedData: any = [];
            var inventData = this.state.inventoryData.filter((itemObj: any) => {
                if (itemObj.name.match(item.name)) {
                    var obj = { type: itemObj.materialDescription, summary: itemObj.packingType, amount: itemObj.qTY, hour: '' }
                    nestedData.push(obj);
                    return obj;
                }
            });

            var totalQty = this.sumProperty(nestedData, 'amount');
            var totalLbs = this.sumProperty(inventData, 'cubeQTY');

            return <MoveListCard
                key={index}
                title={item.name}
                // onClick={(item: any) => this.openMoveDetail(item)}
                text={"Total"}
                totalValue={totalQty + " (" + totalLbs + " lbs)"}
                data={nestedData}
            />
        })

        return items;
    }

    onSignFirst() {

        let estsigns = this.sigCanvasFirst.toDataURL('image/png').replace('data:image/png;base64,', '')
        //let errorMsg = this.sigCanvasFirst._sigPad.points.length <= 1 ? true : false;
        let arr = this.sigCanvasFirst?.toData();
        let combine: any = [];
        arr?.forEach((d: any) => {
            combine = [...combine, ...d]
        })
        console.log("arrr", combine?.length)
        this.setState({ signErrorMsg: combine?.length < 16 ? true : false });
        localStorage.setItem("estsigns", estsigns);
        this.props.getSignFlag(estsigns, combine?.length > 15)
    }
    saveSignatures(flag: string) {
        var Customer = JSON.parse(localStorage.getItem("customerDetails") || '{}')
        var params = {
            customerID: Customer.customerID,
            moveID: Customer.moveID,
            moveDailySheetID: Customer.moveDailySheetID,
            estimatorID: Customer.estimatorID,
            signature1: localStorage.getItem("estsigns"),
            signature2: ""
        }
        console.log("PARAMS", params)
        this.saveSignaturesAPI(params)
            .then(response => {

            });

    }
    async saveSignaturesAPI(params: any) {
        return client.query({
            query: saveSignatures, variables: {
                sigInput: {
                    "customerID": params.customerID,
                    "moveID": params.moveID,
                    "moveDailySheetID": params.moveDailySheetID,
                    "estimatorID": params.estimatorID,
                    "signature1": params.signature1,
                    "signature2": params.signature2
                }
            }
        });
    }


    render() {
        console.log("response", this.state.responseEstDetail);
        let packing = (parseFloat(this.state.responseEstDetail.materialCost) + parseFloat(this.state.responseEstDetail.packingCost)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        return (

            this.state.loading ? <Spinner /> :

                <div>

                    <CardLayout>

                        <div className="summary-detail">
                            <h1>Transportation & Related Services:</h1>
                            {/* <h3><span>All My Sons Moving & Storage of Dallas, LLC.</span></h3> */}
                            <h3><span>${parseFloat(this.state.responseEstDetail?.transportationValue || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></h3>
                        </div>
                        <div className="summary-detail">
                            <h1>Packing Materials:</h1>
                            {/* <h3>2400 Old Mill Rd. Carrollton, TX 75007</h3> */}
                            <h3><span>${packing}</span></h3>
                        </div>
                        <div className="summary-detail">
                            <h1>Basic move cost:</h1>
                            {/* <h3>All My Sons Moving & Storage of Dallas, LLC</h3> */}
                            <h3><span>${parseFloat(this.state.responseEstDetail?.totalChargesAfterDisc || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></h3>
                        </div>

                    </CardLayout>

                    <CardLayout>
                        <div>
                            <div className="valuation">
                                <h2>Valuation Options & Applicable Move Cost</h2>
                                <h1>
                                    Estimate Total is good for 7 days  unless signed by all parties</h1>
                                <br />
                                <div className="shippernote">
                                    Note: Shipper- You will Select your level of Valuation Liability Protection (Option 1 or 2) the day of your move on your Bill of Lading!
                                </div>
                            </div>
                            <br />
                            <div className="summary-detail topMargin ">
                                <h1>Declared Value of Shipment:<br />
                                    <span>
                                        Shipment weight times $6.00/lb.
                                    </span></h1>
                                {/* <h3>All My Sons Moving & Storage of Dallas, LLC</h3> */}
                                <h3><span>${parseFloat(this.state.EstimatorDetails.shipmentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></h3>
                            </div>


                            <div className="optionContainer">
                                <h2>Option 1</h2>
                                <h3>Full Replacement Value Protection/ $0 Deductible Cost</h3>
                                <div className="summary-detail topMargin ">
                                    <h1>Cost:</h1>
                                    <h3>${this.state.responseEstDetail.protectionCharges}</h3>
                                </div>
                                <div className="summary-detail topBorder">
                                    <h1>Total Binding Move Cost:</h1>
                                    <h3><span>${parseFloat(this.state.responseEstDetail?.totalCharges || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></h3>
                                </div>
                            </div>
                            <div className="footerData">
                                This cost estimate includes Full Value Replacement Value Protection based on a valuation amount equal to $6.00 multiplied by the weight (in pounds) of your shipment, subject to a minimum valuation amount of $6,000.00. If any article is lost, destroyed or damaged while in your mover's custody, your mover will, at its option, either 1) repair the article to the extent necessary to restore it to the same condition as when it was received by your mover, or pay you for the cost of such repairs; or 2) replace the article with an article of like kind and quality, or 3) pay you for the cost of such a replacement. IF you wish to declare a higher value for your shipment than the minimum amounts, that amount is shown above:
                            </div>
                            <div className="optionContainer">
                                <h2>Option 2</h2>
                                <h3>*Basic Liability/WAIVE Replacement Value</h3>
                                <div className="summary-detail topMargin ">
                                    <h1>Cost:</h1>
                                    <h3>$ 0.00</h3>
                                </div>
                                <div className="summary-detail topBorder">
                                    <h1>Total Binding Move Cost:</h1>
                                    <h3><span>${parseFloat(this.state.responseEstDetail?.totalChargesAfterDisc || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></h3>
                                </div>
                            </div>
                            <div className="footerData">
                                *Basic Liability Protection is a lower level of protection and provided at no additional cost; however, it provides only minimal protection that is considerably less than the average value of household goods.  Under this option, a claim for any article that may be lost, destroyed, or damaged while in your mover’s custody will be settled  based on the weight of the individual article multiplied by 60 cents. <b>For example, the settlement for a piece of furniture that weighs 100 pounds would be $60.00 (100 pounds times 60 cents).</b>
                            </div>
                        </div>
                    </CardLayout>

                    <CardLayout>
                        <div className="estimateTitle">Estimator (Sales Representative)</div>

                        <div className="summary-detail">
                            <h1>Name:</h1>
                            <h3>{this.state.customerDetails.estimatorName}</h3>
                        </div>

                        <div className="summary-detail">
                            <h1>Cell:</h1>
                            <h3>{this.state.customerDetails.estimatorPhone}</h3>
                        </div>

                        <div className="summary-detail">
                            <h1>Email:</h1>
                            <h3><a href="mailto:estimator@allmysons.com">{this.state.EstimatorDetails?.estimatorEmail}</a></h3>
                        </div>

                    </CardLayout>
                    <CardLayout>
                        <div className="estimateTitle">Customer Service Needs (Care Team)</div>
                        <div className="serviceNeeds"><h5><b>Your All My Sons Customer Care Team</b> is always available to assist and can be contacted anytime at </h5></div>
                        <div className="serviceNeeds"> {this.state.EstimatorDetails.customerCarePhone}</div>
                        <div className="serviceNeeds"><span>or</span></div>
                        <div className="serviceNeeds"><a href="mailto:AMScustomercare@allmysons.com">{this.state.EstimatorDetails.customerCareEmail}</a></div>


                    </CardLayout>
                    <CardLayout>
                        <div className="serviceNeeds">
                            <h5 style={{ fontSize: "12pt", fontWeight: "bold" }}> This estimate is Binding upon you (the Shipper) and the Carrier, {this.state.customerDetails.destination}. The charges identified are only for services and assessed and defined by this estimate. You will be required to pay 100% of the original agreed binding estimate PRIOR to offloading at the time of delivery.</h5></div>
                        <div className="summary-detail">
                            <div className="signature"><img src={this.state.EstimatorDetails.estimatorSign}></img></div>

                            <div className="signatureDate">{this.state.EstimatorDetails.estimateDate}</div>
                        </div>
                        <div className="summary-detail">
                            <div className="signatureText">{this.state.customerDetails.estimatorName}</div>
                            <div className="signatureText" style={{ width: "30%" }}>DATE</div>
                        </div>
                    </CardLayout>
                    <CardLayout style={{ padding: "2em" }}>
                        <div className="summary-detail">
                            <div className="signatureHead">Draw My Signature</div>
                            <div className="clearText" onClick={this.clearFirst}>CLEAR</div>

                        </div>
                        <br />
                        <div className="valuation">
                            <div className="shippernote">
                                Remember, you will select your valuation option later.
                            </div>
                        </div>
                        <br />
                        {/* <div className="summary-detail">
                            <div className="signatureText">
                                By signing here, I confirm my move is complete and to process my payment.
                            </div>
                        </div> */}
                        <br />
                        <div className="sign-hereBtn">SIGN HERE</div>
                        <div className="sign-here">
                            <div className="sign-detail" id="estimate-sign">
                                {/* fromDataURL(base64String, options) */}
                                <SignatureCanvas penColor='black' velocityFilterWeight={1}
                                    onEnd={() => this.onSignFirst()}
                                    ref={(ref: any) => this.sigCanvasFirst = ref}
                                    canvasProps={{ width: window.innerWidth - 100, height: 100, className: 'sigCanvas', id: 'sign-estimate-canvas' }} />
                                <div className="signature-line"></div>
                            </div>
                            <div className="signFooter">
                                {this.state.customerDetails.customerName}, Shipper
                            </div>
                            {this.state.signErrorMsg && <div className="signFooterNote">
                                <span>
                                    AN ELIGIBLE SIGNATURE REQUIRES
                                    MORE MARKS To Be Acceptable
                                </span>
                            </div>}
                        </div>
                    </CardLayout>
                </div>

        );
    }
}

export default MoveSummaryCard;